<template>
  <div class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-3">
          <import-file-input v-model="formData.file"></import-file-input>
          <validation-error :model-error="formErrors.file"></validation-error>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AutoCallSystem from '@/models/AutoCallSystem'
import { EventBus } from '@/../eventbus.js'
import ImportFileInput from '@/components/form-inputs/ImportFileInput'

export default {
  name: 'Shared.AutoCallSystem.UploadData',
  components: {
    ImportFileInput
  },
  data () {
    return {
      formData: {
        file: null
      },
      formErrors: {}
    }
  },
  mounted () {
    EventBus.$on('initResetFormData', this.initResetFormData)
    EventBus.$on('initUploadAutoCallSystemData', this.uploadData)
  },
  methods: {
    async initResetFormData () {
      this.formData = {
        file: ''
      }
      this.formErrors = {}
    },
    async uploadData () {

      this.$vs.loading({background: 'primary', color: '#fff', container: '#uploadButton', scale: 0.45})

      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await AutoCallSystem.store(this.formData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.$store.dispatch('setIsFormInProgress', false)

          this.initResetFormData()
          this.$emit('uploadSuccess')

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.formErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }

      this.$vs.loading.close('#uploadButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#uploadButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
